// @core/api/endpoints/billing/get_account.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  GetAccountResponse,
} from '../../../types/billing';

const BASE_PATH = '/billing';

/**
 * Get account by ID
 * Retrieves a Chart of Accounts entry by its unique identifier. Returns the account details including type, subtype, and current balance.
 */
export async function GetAccount(
  id: string,
  options?: RequestOptions
): Promise<GetAccountResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/accounts/:id`;
  requestPath = requestPath.replace(':id', encodeURIComponent(id));
  const requestOptions = options;
  return client.get<GetAccountResponse>(requestPath, { ...requestOptions });
}
